import { render } from "./base.vue?vue&type=template&id=129fcee8&ts=true"
import script from "./base.vue?vue&type=script&lang=ts"
export * from "./base.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/cow-app/cow-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__